import axios from 'axios';

const photoApi = axios.create({
  baseURL: 'https://portail.ipmodec.com', // URL pour les photos
});

export default photoApi;
